{
  "familyId": "TOPO-WERELD-RIVIER",
  "questions": [
    {
      "id": "TOPO-WERELD-RIVIER-001",
      "familyId": "TOPO-WERELD-RIVIER",
      "module": "Topo",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "wereld",
      "subSkill": "topo_rivieren_wereld",
      "questionType": "multiple_choice",
      "question": "Welke rivier is de langste ter wereld?",
      "options": ["De Nijl", "De Amazone", "De Mississippi", "De Donau"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Langste rivieren ter wereld",
            "content": "De Nijl (Afrika) is de langste rivier ter wereld (~6.650 km). De Amazone (Zuid-Amerika) is de breedste en heeft het meeste water.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "rivier_wereld_langste",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 2
      },
      "feedback": {
        "explanationText": "De Nijl in Afrika is de langste rivier ter wereld (~6.650 km). De Amazone is de breedste en heeft het meeste water, maar is iets korter.",
        "solutionSteps": [
          "Langste rivier: de Nijl (Afrika)",
          "Lengte: ~6.650 km",
          "De Amazone is de breedste (meeste water)"
        ],
        "distractorExplanations": {
          "0": "Goed! De Nijl is de langste rivier ter wereld.",
          "1": "Je dacht waarschijnlijk aan de Amazone. De Amazone heeft het meeste water en is de breedste, maar de Nijl is iets langer.",
          "2": "Je dacht waarschijnlijk aan de Mississippi. De Mississippi is een grote rivier in Noord-Amerika, maar niet de langste ter wereld.",
          "3": "Je dacht waarschijnlijk aan de Donau. De Donau is de langste rivier van Europa, maar niet van de wereld."
        }
      }
    },
    {
      "id": "TOPO-WERELD-RIVIER-002",
      "familyId": "TOPO-WERELD-RIVIER",
      "module": "Topo",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "wereld",
      "subSkill": "topo_rivieren_wereld",
      "questionType": "multiple_choice",
      "question": "Door welk continent stroomt de Amazone?",
      "options": ["Zuid-Amerika", "Afrika", "Azië", "Noord-Amerika"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Rivieren en continenten",
            "content": "De Amazone stroomt door Zuid-Amerika (vooral Brazilië). De Nijl door Afrika. De Ganges door Azië. De Mississippi door Noord-Amerika.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "rivier_wereld_continent",
      "variantIndex": 2,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "De Amazone stroomt door Zuid-Amerika, vooral door Brazilië. Het is de rivier met het meeste water ter wereld.",
        "solutionSteps": [
          "De Amazone stroomt door Zuid-Amerika",
          "Vooral door Brazilië",
          "Grootste stroomgebied ter wereld"
        ],
        "distractorExplanations": {
          "0": "Goed! De Amazone stroomt door Zuid-Amerika.",
          "1": "Je dacht waarschijnlijk aan Afrika. Maar de grote rivier van Afrika is de Nijl. De Amazone is in Zuid-Amerika.",
          "2": "Je dacht waarschijnlijk aan Azië. Maar de grote rivieren van Azië zijn de Ganges, de Yangtze en de Mekong. De Amazone is in Zuid-Amerika.",
          "3": "Je dacht waarschijnlijk aan Noord-Amerika. Maar de grote rivier van Noord-Amerika is de Mississippi. De Amazone is in Zuid-Amerika."
        }
      }
    },
    {
      "id": "TOPO-WERELD-RIVIER-003",
      "familyId": "TOPO-WERELD-RIVIER",
      "module": "Topo",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "wereld",
      "subSkill": "topo_rivieren_wereld",
      "questionType": "multiple_choice",
      "question": "De Ganges is een heilige rivier. In welk land stroomt de Ganges?",
      "options": ["India", "China", "Egypte", "Brazilië"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De Ganges",
            "content": "De Ganges stroomt door India en Bangladesh. Het is een heilige rivier in het hindoeïsme. Miljoenen mensen wonen langs de Ganges.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "rivier_wereld_ganges",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De Ganges stroomt door India (en Bangladesh). Het is een heilige rivier in het hindoeïsme.",
        "solutionSteps": [
          "De Ganges stroomt door India",
          "Heilige rivier in het hindoeïsme",
          "Mondt uit in de Golf van Bengalen"
        ],
        "distractorExplanations": {
          "0": "Goed! De Ganges stroomt door India.",
          "1": "Je dacht waarschijnlijk aan China. De grote rivieren van China zijn de Yangtze en de Gele Rivier. De Ganges is in India.",
          "2": "Je dacht waarschijnlijk aan Egypte. De grote rivier van Egypte is de Nijl. De Ganges is in India.",
          "3": "Je dacht waarschijnlijk aan Brazilië. De grote rivier van Brazilië is de Amazone. De Ganges is in India."
        }
      }
    },
    {
      "id": "TOPO-WERELD-RIVIER-004",
      "familyId": "TOPO-WERELD-RIVIER",
      "module": "Topo",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "wereld",
      "subSkill": "topo_rivieren_wereld",
      "questionType": "multiple_choice",
      "question": "Welke rivier stroomt door China en is de langste rivier van Azië?",
      "options": ["De Yangtze", "De Ganges", "De Mekong", "De Nijl"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Rivieren van Azië",
            "content": "De Yangtze (Chang Jiang) is de langste rivier van Azië (~6.300 km). De Ganges stroomt door India. De Mekong door Zuidoost-Azië.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "rivier_wereld_yangtze",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De Yangtze (ook wel Chang Jiang) is de langste rivier van Azië (~6.300 km) en stroomt door China.",
        "solutionSteps": [
          "Langste rivier van Azië: de Yangtze",
          "Stroomt door China",
          "Lengte: ~6.300 km"
        ],
        "distractorExplanations": {
          "0": "Goed! De Yangtze is de langste rivier van Azië.",
          "1": "Je dacht waarschijnlijk aan de Ganges. De Ganges stroomt door India, niet door China. De Yangtze is de langste van Azië.",
          "2": "Je dacht waarschijnlijk aan de Mekong. De Mekong stroomt door Zuidoost-Azië, maar is korter dan de Yangtze.",
          "3": "Je dacht waarschijnlijk aan de Nijl. Maar de Nijl stroomt door Afrika, niet door Azië."
        }
      }
    },
    {
      "id": "TOPO-WERELD-RIVIER-005",
      "familyId": "TOPO-WERELD-RIVIER",
      "module": "Topo",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "wereld",
      "subSkill": "topo_rivieren_wereld",
      "questionType": "matching",
      "question": "Koppel elke rivier aan het juiste continent.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "leftItems": ["Nijl", "Amazone", "Mississippi", "Ganges"],
        "rightItems": ["Afrika", "Zuid-Amerika", "Noord-Amerika", "Azië"],
        "correctMatches": { "0": 0, "1": 1, "2": 2, "3": 3 }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Rivieren en continenten",
            "content": "Nijl → Afrika. Amazone → Zuid-Amerika. Mississippi → Noord-Amerika. Ganges → Azië (India).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "rivier_wereld_koppelen",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Nijl → Afrika. Amazone → Zuid-Amerika. Mississippi → Noord-Amerika. Ganges → Azië.",
        "solutionSteps": [
          "Nijl → Afrika (Egypte, Soedan)",
          "Amazone → Zuid-Amerika (Brazilië)",
          "Mississippi → Noord-Amerika (VS)",
          "Ganges → Azië (India)"
        ]
      }
    }
  ]
}